// Per-category header theme + live-background mapping.
// Each category: live-bg variant, accent pair, and the most relevant tool/method chips.
// Kept deliberately small so headers are not overcrowded.
export const CATEGORY_THEME = {
  projects: {
    variant: "blueprint",
    accent: "eblue",
    accent2: "cyan",
    chips: ["RCA", "Automation", "Analytics", "IoT", "Quality Systems", "Continuous Improvement"],
  },
  "product-quality": {
    variant: "quality",
    accent: "teal",
    accent2: "success",
    chips: ["FPY", "Lot Genealogy", "Specification Review", "Trending", "Yield", "Acceptance Criteria"],
  },
  "rca-lab": {
    variant: "pareto",
    accent: "warn",
    accent2: "critical",
    chips: ["Fishbone", "Pareto", "Stratification", "Hypothesis Testing", "Comparative Analysis"],
  },
  "continuous-improvement": {
    variant: "pdca",
    accent: "success",
    accent2: "teal",
    chips: ["PDCA", "DMAIC", "KPI Governance", "Variation Reduction", "Yield Recovery", "Effectiveness Checks"],
  },
  automation: {
    variant: "pipeline",
    accent: "cyan",
    accent2: "eblue",
    chips: ["Python", "REST APIs", "pandas", "Validation", "Reconciliation", "Exception Handling"],
  },
  iot: {
    variant: "mesh",
    accent: "cyan",
    accent2: "violet",
    chips: ["Sensors", "Telemetry", "Time-Series", "Gap Detection", "Sync", "Data Integrity"],
  },
  "analytics-lab": {
    variant: "scatter",
    accent: "eblue",
    accent2: "cyan",
    chips: ["JMP", "Power BI", "Trend Detection", "Multivariable Analysis", "Feature Extraction"],
  },
  qms: {
    variant: "lifecycle",
    accent: "violet",
    accent2: "eblue",
    chips: ["SOP", "WI", "Deviation", "CAPA", "Change Control", "ALCOA+"],
  },
  expertise: {
    variant: "lattice",
    accent: "teal",
    accent2: "violet",
    chips: ["Product Quality", "QMS", "Automation", "Analytics", "Compliance", "Operational Excellence"],
  },
  about: {
    variant: "precision",
    accent: "teal",
    accent2: "cyan",
    chips: [],
  },
};
